import { Col, Row, Switch } from 'antd';
import React, { Component } from 'react';

import { ColumnDisplayList } from './GroupDetail';

interface Props {
  onSelectDisplayColumnChange: Function;
}

export class SelectDisplayColumn extends Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    const { onSelectDisplayColumnChange } = this.props;
    return (
      <>
        <Row gutter={24}>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            意向度:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
              defaultChecked
              onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.INTENTIONALITY)}
            />
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            通话次数:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
              defaultChecked
              onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.NUMBER_OF_CALLS)}
            />
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            跟进记录:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
              defaultChecked
              onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.LAST_INTENT)}
            />
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            测评等级:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
              defaultChecked
              onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.EVALUATION_LEVEL)}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          {/* <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            邀请返学费:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
              defaultChecked
              onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.INVITATION_FOR_RETURN_FEE)}
            />
          </Col> */}
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            累计完课:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
              defaultChecked
              onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.TOTAL_LESSON_PROGRESS)}
            />
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            累计打卡:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
              defaultChecked
              onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.TOTAL_CLOCK_IN)}
            />
          </Col>
          {/* <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            赠课活动:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
              defaultChecked
              onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.LESSON_GIVING_ACTIVITIES)}
            />
          </Col> */}
        </Row>

        {/* <Row gutter={24}> */}
        {/* <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            续费状态:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
             defaultChecked
              onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.RENEWAL_STATUS)} />
          </Col> */}
        {/* <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            回访督学:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
              defaultChecked
            onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.SUPERINTENDENT)} />
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            活动跟进:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
              defaultChecked
              onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.FOLLOW_UP_ACTIVITIES)}
            />
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            添加微信:
          </Col>
          <Col style={{ marginTop: 8 }} xs={12} md={6} lg={3} xl={3} xxl={3}>
            <Switch
              defaultChecked
             onChange={checked => onSelectDisplayColumnChange(checked, ColumnDisplayList.ADD_WECHAT)} />
          </Col> */}

        {/* </Row> */}
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/group/SelectDisplayColumn.tsx